export default "__VITE_ASSET__CMJ7JTqO__"